// DEV URL
// var baseUrl = "https://taf-django.withvolkeno.com";

// DEMO API BASE URL
// var baseUrl = 'https://demo.api.taf-django.withvolkeno.com'

// PREPROD API BASE URL
var baseUrl = "https://api.tafafricaglobal.com";

export default baseUrl;